import HomeView from '../views/HomeView.vue'
import AbrofSubscribtion from '../views/AbrofSubscribtion.vue'

export const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import(/* webpackChunkName: "categories" */ '../views/CategoriesView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/artists',
    name: 'artists',
    component: () => import(/* webpackChunkName: "artists" */ '../views/ArtistsView.vue'),
    meta: {
      auth: true
    }
  },

  {
    path: '/tracks/:title',
    name: 'tracks',
    component: () => import(/* webpackChunkName: "tracks" */ '../views/TracksView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/playList/:id',
    name: 'playlist',
    component: () => import(/* webpackChunkName: "playlist" */ '../views/PlayList.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/artist/show/:id',
    name: 'artist.show',
    component: () => import(/* webpackChunkName: "showArtist" */ '../views/ShowArtist.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/show/catgories/:id',
    name: 'show.catgories',
    component: () => import(/* webpackChunkName: "cat" */ '../views/CatDetails.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/search/results',
    name: 'search.resutls',
    component: () => import(/* webpackChunkName: "Youth" */ '../views/SearchResults.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/libarary',
    name: 'libarary',
    component: () => import(/* webpackChunkName: "lib" */ '../views/LibView.vue'),
    meta: {
      auth: true
    }

  },
  {
    path: '/libarary/favorites',
    name: 'libarary.favorites',
    component: () => import(/* webpackChunkName: "lib-favorites" */ '../views/library/FavoritesList.vue'),
    meta: {
      auth: true
    }

  },
  {
    path: '/libarary/followed/artists',
    name: 'libarary.artists.followed',
    component: () => import(/* webpackChunkName: "lib" */ '../views/library/FollowedArtists.vue'),
    meta: {
      auth: true
    }

  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: () => import(/* webpackChunkName: "abrofSub" */ '../views/auth/SubscribeView.vue')

  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "abrofSub" */ '../views/auth/ProfileView.vue')

  }
  ,
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/auth/LoginView.vue')

  }
  ,
  {
    path: '/subscribe/:num',
    name: 'abrof.subscribe',
   
    component: AbrofSubscribtion

  },
  {
    path: '/login/subscribe_ok/:num',
    name: 'abrof.subscribe',
    // route level code-splitting
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "abrofSub" */ '../views/AbrofSubscribtion.vue')
  },

  {
    path: '/success',
    name: 'success',
    component: () => import(/* webpackChunkName: "success" */ '../views/SuccessView.vue')
  }
]

